'use client';

import { Facebook, Twitter, Link2, MessageCircle } from 'lucide-react';
import { useState } from 'react';

interface Props {
  title: string;
  slug: string;
}

export default function SocialShareButtons({ title, slug }: Props) {
  const [copied, setCopied] = useState(false);
  const fullUrl = `https://hizlicicek.com/${slug}`;
  const encodedUrl = encodeURIComponent(fullUrl);
  const encodedTitle = encodeURIComponent(title);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(fullUrl);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch {
      // Fallback for older browsers
      const input = document.createElement('input');
      input.value = fullUrl;
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      input.remove();
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  };

  const buttons = [
    {
      label: 'WhatsApp',
      icon: <MessageCircle size={18} />,
      href: `https://wa.me/?text=${encodedTitle}%20${encodedUrl}`,
      className: 'hover:bg-green-50 hover:text-green-600 hover:border-green-200',
    },
    {
      label: 'Facebook',
      icon: <Facebook size={18} />,
      href: `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`,
      className: 'hover:bg-blue-50 hover:text-blue-600 hover:border-blue-200',
    },
    {
      label: 'Twitter',
      icon: <Twitter size={18} />,
      href: `https://twitter.com/intent/tweet?text=${encodedTitle}&url=${encodedUrl}`,
      className: 'hover:bg-sky-50 hover:text-sky-500 hover:border-sky-200',
    },
  ];

  return (
    <div className="flex items-center gap-2 flex-wrap">
      {buttons.map((btn) => (
        <a
          key={btn.label}
          href={btn.href}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`${btn.label} ile paylaş`}
          className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-gray-200 text-gray-500 text-xs font-medium transition-all duration-200 ${btn.className}`}
        >
          {btn.icon}
          <span className="hidden sm:inline">{btn.label}</span>
        </a>
      ))}
      <button
        onClick={handleCopy}
        aria-label="Bağlantıyı kopyala"
        className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full border text-xs font-medium transition-all duration-200 ${
          copied
            ? 'border-green-300 bg-green-50 text-green-600'
            : 'border-gray-200 text-gray-500 hover:bg-gray-50 hover:text-gray-700 hover:border-gray-300'
        }`}
      >
        <Link2 size={18} />
        <span className="hidden sm:inline">{copied ? 'Kopyalandı!' : 'Kopyala'}</span>
      </button>
    </div>
  );
}
